import { ColumnApi } from '@ag-grid-community/core/dist/cjs/columnController/columnApi';
import { GridApi } from '@ag-grid-community/core/dist/cjs/gridApi';
import React, { useEffect, useState } from 'react';

import { useColumnPresetState } from '../../../pages/FinancialData/shared/ColumnPresetContext/ColumnPresetContext';
import ColumnPresets, { ColumnPreset } from './ColumnPresets';

interface Props {
  systemDefaultFields: string[];
  systemDefaultPresets: ColumnPreset[];
  columnsApi: ColumnApi;
  gridApi?: GridApi;
}

const TableGridColumnPresets: React.FC<Props> = ({
  systemDefaultFields,
  systemDefaultPresets,
  columnsApi,
  gridApi,
}) => {
  const currentlyVisibleColumns = () => {
    return (
      (columnsApi?.getAllColumns() ?? [])
        .filter((f) => f.isVisible() && f.getColDef().field)
        .map((f) => f.getColDef().field!) ?? []
    );
  };

  const { presetColumns, onPresetColumnsChange } = useColumnPresetState();
  const [visibleColumns, setVisibleColumns] = useState(currentlyVisibleColumns());

  const onSelectionChanged = () => {
    setVisibleColumns(currentlyVisibleColumns());
  };

  useEffect(() => {
    gridApi?.addEventListener('columnVisible', onSelectionChanged);

    return () => {
      gridApi?.removeEventListener('columnVisible', onSelectionChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridApi]);

  const activatePreset = (ids: string[]) => {
    const cols = columnsApi?.getAllColumns() ?? [];
    columnsApi?.setColumnsVisible(
      cols.filter((c) => c.getColDef().field && ids.indexOf(c.getColDef().field!) >= 0),
      true,
    );
    columnsApi?.setColumnsVisible(
      cols.filter((c) => c.getColDef().field && ids.indexOf(c.getColDef().field!) === -1),
      false,
    );
  };

  const onSave = () => {
    onPresetColumnsChange(currentlyVisibleColumns());
  };

  return (
    <ColumnPresets
      systemDefaultFields={systemDefaultFields}
      systemDefaultPresets={systemDefaultPresets}
      selectedColumns={visibleColumns}
      presetColumns={presetColumns}
      onActivatePreset={activatePreset}
      onSaveSelectedAsPresetColumns={onSave}
    />
  );
};

export default TableGridColumnPresets;
